export default "__VITE_ASSET__BcENNBKn__"